import * as _ from 'lodash';
import * as moment from 'moment';
import { Component } from 'react';
import { Alert, Button, Panel } from 'react-bootstrap';
import Progress from './progress';
import SelectFile from './select-file';
import ColumnMapping from './column-mapping';
import {
    AppActionCreators, IApplicationState, CenterActionCreators,
    IOptnSrtrDataUploadResponse, IOptnSrtrDataValidateResponse, IOptnSrtrDataProcessResponse, IOptnSrtrDataProgressResponse, IOptnSrtrMonthlyDataResponse, IUpdateOptnSrtrData, IOptnSrtrMonthlyDataAddResponse, IAppState
} from '@nkr/store/index';
import { connect, Dispatch } from 'react-redux';
import { DropEvent, FileRejection } from 'react-dropzone';
import { IBaseResponse, ICenterBase, ICenterUnosDataMonthlyWithStatus, IOptnSrtrValidation } from '@nkr/models/index';
import Verify from './verify';
import Process from './process';
import MonthlyData from './monthly-data';
import AddData from './add-data';
import ConfirmDelete from './confirm-delete';
import { LoadingIndicator } from '@nkr/components/loading-indicator';
import { AxiosError } from 'axios';
import { GridApi, GridReadyEvent, RowSelectedEvent } from 'ag-grid-community';

enum Steps {
    SelectFile = 1,
    ColumnMapping = 2,
    VerifyData = 3,
    Processing = 4,
    Complete = 5
}

export const steps = [
    { id: Steps.SelectFile, label: 'Select File to Upload' },
    { id: Steps.ColumnMapping, label: 'Specify Column Mapping' },
    { id: Steps.VerifyData, label: 'Verify Data' },
    { id: Steps.Processing, label: 'Processing' },
    { id: Steps.Complete, label: 'Complete' },
]

const devColumns = [
    'Center', 'DateCode', 'LDTransplants', 'DDTransplants', 'WaitlistTotal', 'WaitlistActive',
    'LivingDonorsABO_A', 'LivingDonorsABO_B', 'LivingDonorsABO_AB', 'LivingDonorsABO_O',
    'LivingDonorRecipientsABO_A', 'LivingDonorRecipientsABO_B', 'LivingDonorRecipientsABO_AB', 'LivingDonorRecipientsABO_O'
];

export interface IProgress {
    rowsProcessed: number,
    rowsAdded: number,
    rowsUpdated: number,
    rowsSkipped: number
}

interface IProps {
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    uploadOptnSrtrData: (hasColumnHeaders: boolean, file: File) => Promise<IOptnSrtrDataUploadResponse>,
    validateOptnSrtrData: (fileName: string, hasColumnHeaders: boolean, columnMappings: string[]) => Promise<IOptnSrtrDataValidateResponse>,
    processOptnSrtrData: (fileName: string, hasColumnHeaders: boolean, columnMappings: string[]) => Promise<IOptnSrtrDataProcessResponse>,
    getOptnSrtrProgress: (id: number) => Promise<IOptnSrtrDataProgressResponse>,
    getOptnSrtrMonthlyData: () => Promise<IOptnSrtrMonthlyDataResponse>,
    updateOptnSrtrData: (data: IUpdateOptnSrtrData[]) => Promise<IBaseResponse>,
    addOptnSrtrData: (data: IUpdateOptnSrtrData) => Promise<IOptnSrtrMonthlyDataAddResponse>,
    deleteOptnSrtrData: (list: number[]) => Promise<IBaseResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    step: Steps,
    files: File[],
    columnsFromFile: string[],
    assignedColumns: string[],
    sampleRow: string[],
    hasColumnHeaders: boolean,
    fileName: string,
    validatedData: IOptnSrtrValidation[],
    progressId: number,
    progress: IProgress,
    loadingMonthlyData: boolean,
    monthlyData: ICenterUnosDataMonthlyWithStatus[],
    centers: ICenterBase[],
    showAddData: boolean,
    // showDeleteButton: boolean,
    showDelete: boolean,
    error: {
        show: boolean,
        message: string
    },
    gridApi: GridApi
}

class UpdateOptnSrtrData extends Component<TProps, IState> {
    readonly state: IState = {
        step: Steps.SelectFile,
        files: [],
        columnsFromFile: [],
        assignedColumns: __ENVIRONMENT__ == 'dev' ? devColumns : [],
        sampleRow: [],
        hasColumnHeaders: true,
        fileName: __ENVIRONMENT__ == 'dev' ? 'D41D8CD98F00B204E9800998ECF8427E.csv' : '',
        validatedData: [],
        progressId: 5,
        progress: {
            rowsProcessed: 0,
            rowsAdded: 0,
            rowsUpdated: 0,
            rowsSkipped: 0
        },
        loadingMonthlyData: true,
        monthlyData: [],
        centers: [],
        showAddData: false,
        // showDeleteButton: false,
        showDelete: false,
        error: {
            show: false,
            message: ''
        },
        gridApi: null
    }

    refreshInterval: any;

    onMonthlyDataGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    // onRowSelected = (e:RowSelectedEvent)=> {
    //     let rows = e.api.getSelectedNodes().filter(x => x.isSelected());

    //     this.setState({
    //         showDeleteButton: rows.length > 0
    //     });
    // }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        if (this.state.step == Steps.ColumnMapping) {
            this.validateFile();
        }

        if (this.state.step == Steps.Processing) {
            this.refreshInterval = setInterval(() => this.refresh(), 1000);
        }

        if (this.state.step == Steps.Complete) {
            this.setState({
                step: Steps.Complete,
                loadingMonthlyData: true
            }, () => {
                this.getMonthlyData();
            });
        }
    }

    refresh = () => {
        this.setState({
            // loading: true
        }, () => {
            this.props.getOptnSrtrProgress(this.state.progressId)
                .then(async response => {
                    if (response.data.results.isComplete == false) {
                        this.setState({
                            progress: response.data.results.progressModel
                        });
                    } else {
                        this.setState({
                            step: Steps.Complete,
                            loadingMonthlyData: true
                        }, () => {
                            clearInterval(this.refreshInterval);
                        });

                        let dataResponse = await this.props.getOptnSrtrMonthlyData();

                        if (dataResponse.data.success) {
                            let { data, centers } = dataResponse.data.results;

                            let monthlyData = data.map(x => {
                                let ddTxpsOriginal = x.ddTxps;
                                let ldTxpsOriginal = x.ldTxps;
                                let wlTotalOriginal = x.wlTotal;
                                let wlActiveOriginal = x.wlActive;

                                let ldaOriginal = x.lda;
                                let ldbOriginal = x.ldb;
                                let ldabOriginal = x.ldab;
                                let ldoOriginal = x.ldo;

                                let ldraOriginal = x.ldra;
                                let ldrbOriginal = x.ldrb;
                                let ldrabOriginal = x.ldrab;
                                let ldroOriginal = x.ldro;

                                return {
                                    ...x,
                                    ddTxpsOriginal, ldTxpsOriginal, wlTotalOriginal, wlActiveOriginal,
                                    ldaOriginal, ldbOriginal, ldabOriginal, ldoOriginal,
                                    ldraOriginal, ldrbOriginal, ldrabOriginal, ldroOriginal,
                                    status: 0,
                                    selected: false
                                };
                            });

                            this.setState({
                                monthlyData,
                                centers,
                                loadingMonthlyData: false
                            });
                        }
                    }
                })
                .catch((error: AxiosError) => {
                    this.setState({
                        error: {
                            show: true,
                            message: error.message
                        }
                    });
                });
        });
    }

    uploadFile = () => {
        this.props.showLoading('Uploading file, one moment please...').then(() => {
            this.props.uploadOptnSrtrData(this.state.hasColumnHeaders, this.state.files[0])
                .then(response => {
                    if (response.data.success) {
                        let { fileName, columns: columnsFromFile, sampleRow } = response.data.results;

                        this.setState({
                            step: this.state.step + 1,
                            columnsFromFile,
                            sampleRow,
                            fileName
                        });
                    }

                    this.props.hideLoading();
                })
                .catch((error: AxiosError) => {
                    this.setState({
                        error: {
                            show: true,
                            message: error.message
                        }
                    });
                });
        });
    }

    validateFile = () => {
        this.props.showLoading('Validating file, one moment please...')
            .then(() => {
                this.props.validateOptnSrtrData(this.state.fileName, this.state.hasColumnHeaders, this.state.assignedColumns).then(response => {
                    if (response.data.success) {

                        this.setState({
                            step: this.state.step + 1,
                            validatedData: response.data.results
                        });
                    }

                    this.props.hideLoading();
                })
                    .catch((error: AxiosError) => {
                        this.setState({
                            error: {
                                show: true,
                                message: error.message
                            }
                        });
                    });
            });
    }

    processFile = async () => {
        this.props.processOptnSrtrData(this.state.fileName, this.state.hasColumnHeaders, this.state.assignedColumns)
            .then(response => {
                if (response.data.success) {
                    this.setState({
                        step: this.state.step + 1,
                        progressId: response.data.results
                    }, () => {
                        this.refreshInterval = setInterval(() => this.refresh(), 1000);
                    });
                }
            })
            .catch((error: AxiosError) => {
                this.setState({
                    error: {
                        show: true,
                        message: error.message
                    }
                });
            });
    }

    getMonthlyData = async () => {
        let dataResponse = await this.props.getOptnSrtrMonthlyData();

        if (dataResponse.data.success) {
            let { data, centers } = dataResponse.data.results;

            let monthlyData = data.map(x => {
                let ddTxpsOriginal = x.ddTxps;
                let ldTxpsOriginal = x.ldTxps;
                let wlTotalOriginal = x.wlTotal;
                let wlActiveOriginal = x.wlActive;

                let ldaOriginal = x.lda;
                let ldbOriginal = x.ldb;
                let ldabOriginal = x.ldab;
                let ldoOriginal = x.ldo;

                let ldraOriginal = x.ldra;
                let ldrbOriginal = x.ldrb;
                let ldrabOriginal = x.ldrab;
                let ldroOriginal = x.ldro;

                return {
                    ...x,
                    ddTxpsOriginal, ldTxpsOriginal, wlTotalOriginal, wlActiveOriginal,
                    ldaOriginal, ldbOriginal, ldabOriginal, ldoOriginal,
                    ldraOriginal, ldrbOriginal, ldrabOriginal, ldroOriginal,
                    status: 0,
                    selected: false
                };
            });

            this.setState({
                monthlyData,
                centers,
                loadingMonthlyData: false
            });
        }
    }

    getSelectedData = () => {
        let selectedRows = this.state.gridApi != null ? this.state.gridApi.getSelectedRows() as ICenterUnosDataMonthlyWithStatus[] : [];
        return _.orderBy(selectedRows, x => moment(x.date, 'MM-YYYY'));
    }

    handleNextStep = () => {
        if (this.state.step == Steps.SelectFile) {
            this.uploadFile();
        } else if (this.state.step == Steps.ColumnMapping) {
            this.validateFile();
        } else if (this.state.step == Steps.VerifyData) {
            this.processFile();
        } else {
            this.setState({
                step: this.state.step + 1
            });
        }
    }

    handlePreviousStep = () => {
        this.setState({
            step: this.state.step - 1
        });
    }

    handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        this.setState({
            files: acceptedFiles
        });
    }

    handleRemoveFile = (name: string) => {
        let files = this.state.files.filter(x => x.name != name);

        this.setState({
            files
        });
    }

    handleHasColumnHeadersChange = (hasColumnHeaders: boolean) => {
        this.setState({
            hasColumnHeaders
        });
    }

    handleAssignedColumnChange = (index: number, value: string) => {
        let assignedColumns = [...this.state.assignedColumns];
        assignedColumns[index] = value;

        this.setState({
            assignedColumns
        });
    }

    handleDataChanged = (id: number, property: string, value: string) => {
        let monthlyData = _.cloneDeep(this.state.monthlyData).map(x => {
            if (x.id == id) {
                x[property] = value;

                let hasChanged =
                    x.ddTxps != x.ddTxpsOriginal
                    || x.ldTxps != x.ldTxpsOriginal
                    || x.wlTotal != x.wlTotalOriginal
                    || x.wlActive != x.wlActiveOriginal

                    || x.lda != x.ldaOriginal
                    || x.ldb != x.ldbOriginal
                    || x.ldab != x.ldabOriginal
                    || x.ldo != x.ldoOriginal

                    || x.ldra != x.ldraOriginal
                    || x.ldrb != x.ldrbOriginal
                    || x.ldrab != x.ldrabOriginal
                    || x.ldro != x.ldroOriginal
                    ;

                if (hasChanged) {
                    x.status = 1;
                } else {
                    x.status = 0;
                }
            }

            return x;
        });

        this.setState({
            monthlyData
        });
    }

    handleSavePendingChange = () => {
        let pendingChanges = this.state.monthlyData.filter(x => x.status > 0).map(x => {
            let { id, cId, date, ddTxps, ldTxps, wlTotal, wlActive, lda, ldb, ldab, ldo, ldra, ldrb, ldrab, ldro } = x;

            return {
                id,
                centerId: cId,
                dataDate: moment(date, 'MM-YYYY').format(),

                ddTxps,
                ldTxps,
                wlTotal,
                wlActive,

                lda,
                ldb,
                ldab,
                ldo,

                ldra,
                ldrb,
                ldrab,
                ldro
            };
        });

        this.state.gridApi.stopEditing();

        this.props.showLoading('Updating data, one moment please...').then(() => {
            this.props.updateOptnSrtrData(pendingChanges).then(x => {
                let monthlyData = _.cloneDeep(this.state.monthlyData).map(x => {
                    x.ddTxpsOriginal = x.ddTxps;
                    x.ldTxpsOriginal = x.ldTxps;
                    x.wlTotalOriginal = x.wlTotal;
                    x.wlActiveOriginal = x.wlActive;

                    x.ldaOriginal = x.lda;
                    x.ldbOriginal = x.ldb;
                    x.ldabOriginal = x.ldab;
                    x.ldoOriginal = x.ldo;

                    x.ldraOriginal = x.ldra;
                    x.ldrbOriginal = x.ldrb;
                    x.ldrabOriginal = x.ldrab;
                    x.ldroOriginal = x.ldro;

                    x.status = 0

                    return x;
                });

                this.setState({
                    monthlyData
                }, () => {
                    this.props.hideLoading();
                });
            });
        });
    }

    handleShowAddData = () => {
        this.setState({
            showAddData: true
        });
    }

    handleAddDataSave = (centerId: string, dataDate: string, ddTxps: string, ldTxps: string, wlTotal: string, wlActive: string, lda: string, ldb: string, ldab: string, ldo: string, ldra: string, ldrb: string, ldrab: string, ldro: string) => {
        this.setState({
            showAddData: false
        }, () => {
            let data: IUpdateOptnSrtrData = {
                id: 0,
                centerId: parseInt(centerId),
                dataDate,

                ddTxps,
                ldTxps,
                wlTotal,
                wlActive,

                lda,
                ldb,
                ldab,
                ldo,

                ldra,
                ldrb,
                ldrab,
                ldro
            };

            this.props.showLoading('Saving new center data, one moment please...')
                .then(() => {
                    this.props.addOptnSrtrData(data).then(response => {
                        if (response.data.success) {
                            let {
                                ddTxps: ddTxpsOriginal, ldTxps: ldTxpsOriginal, wlTotal: wlTotalOriginal, wlActive: wlActiveOriginal,
                                lda: ldaOriginal, ldb: ldbOriginal, ldab: ldabOriginal, ldo: ldoOriginal,
                                ldra: ldraOriginal, ldrb: ldrbOriginal, ldrab: ldrabOriginal, ldro: ldroOriginal
                            } = response.data.results;

                            let monthlyData = _.cloneDeep(this.state.monthlyData);

                            monthlyData.push({
                                ...response.data.results,
                                ddTxpsOriginal, ldTxpsOriginal, wlTotalOriginal, wlActiveOriginal,
                                ldaOriginal, ldbOriginal, ldabOriginal, ldoOriginal,
                                ldraOriginal, ldrbOriginal, ldrabOriginal, ldroOriginal,
                                status: 0,
                                selected: false
                            });

                            this.setState({
                                monthlyData
                            });
                        }

                        this.props.hideLoading();
                    });
                })
                .catch((error: AxiosError) => {
                    this.setState({
                        error: {
                            show: true,
                            message: error.message
                        }
                    });
                });
        });
    }

    handleAddDataCancel = () => {
        this.setState({
            showAddData: false
        });
    }

    handleConfirmDelete = () => {
        this.setState({
            showDelete: true
        });
    }

    handleDelete = () => {
        let list = this.getSelectedData().map(x => x.id);

        this.props.showLoading('Deleting selected records, one moment please...')
            .then(() => {
                this.props.deleteOptnSrtrData(list).then(response => {
                    let monthlyData = _.cloneDeep(this.state.monthlyData).filter(x => list.indexOf(x.id) < 0);

                    this.setState({
                        monthlyData,
                        showDelete: false
                    }, () => {
                        this.props.hideLoading();
                    });
                })
                    .catch((error: AxiosError) => {
                        this.setState({
                            error: {
                                show: true,
                                message: error.message
                            }
                        });
                    });
            });
    }

    handleCancelDelete = () => {
        this.setState({
            showDelete: false
        });
    }

    render = () => {
        const currentStep = steps.find(x => x.id == this.state.step);
        const deleteData = this.getSelectedData();

        return (
            <>
                {this.state.error.show && (
                    <Alert bsStyle='danger'>
                        {this.state.error.message}
                    </Alert>
                )}

                <div className='container' style={{ padding: 20 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 30, marginBottom: 20 }}>
                        <div style={{ flexBasis: '33%', fontSize: 28, fontWeight: 500, display: 'flex', alignItems: 'center' }}>
                            OPTN/SRTR Data Update
                        </div>
                    </div>

                    <div>
                        <Progress currentStep={this.state.step} />
                    </div>

                    <Panel bsStyle='primary'>
                        <Panel.Heading>{currentStep.label}</Panel.Heading>
                        <Panel.Body>
                            <div style={{ minHeight: 300 }}>
                                {this.state.step == Steps.SelectFile && (
                                    <SelectFile
                                        files={this.state.files}
                                        hasColumnHeaders={this.state.hasColumnHeaders}
                                        onFileDropped={this.handleFileDropped}
                                        onRemoveFile={this.handleRemoveFile}
                                        onHasColumnHeadersChange={this.handleHasColumnHeadersChange}
                                    />
                                )}

                                {this.state.step == Steps.ColumnMapping && (
                                    <ColumnMapping
                                        columnsFromFile={this.state.columnsFromFile}
                                        assignedColumns={this.state.assignedColumns}
                                        sampleRow={this.state.sampleRow}
                                        hasColumnHeaders={this.state.hasColumnHeaders}
                                        onHasColumnHeadersChange={this.handleHasColumnHeadersChange}
                                        onAssignedColumnChange={this.handleAssignedColumnChange}
                                    />
                                )}

                                {this.state.step == Steps.VerifyData && (
                                    <Verify
                                        columns={this.state.assignedColumns}
                                        data={this.state.validatedData}
                                    />
                                )}

                                {this.state.step == Steps.Processing && (
                                    <Process data={this.state.progress} />
                                )}

                                {this.state.step == Steps.Complete && (
                                    <MonthlyData
                                        data={this.state.monthlyData}
                                        centers={this.state.centers}
                                        loading={this.state.loadingMonthlyData}
                                        isCenter={false}
                                        onGridReady={this.onMonthlyDataGridReady}
                                        // onRowSelected={this.onRowSelected}
                                        onDataChanged={this.handleDataChanged}
                                        onSavePendingChanges={this.handleSavePendingChange}
                                        onAddData={this.handleShowAddData}
                                        onDeleteData={this.handleConfirmDelete}
                                    />
                                )}
                            </div>
                        </Panel.Body>
                    </Panel>

                    <div className='text-right'>
                        <Button disabled={this.state.step == Steps.SelectFile} style={{ marginRight: 10 }} onClick={this.handlePreviousStep}>&lt; &lt; Previous</Button>
                        <Button disabled={this.state.step == Steps.Complete} bsStyle='primary' onClick={this.handleNextStep}>Next &gt;&gt;</Button>
                    </div>
                </div>

                <AddData
                    show={this.state.showAddData}
                    centers={this.state.centers}
                    centerId={0}
                    showCenter={true}
                    onSave={this.handleAddDataSave}
                    onCancel={this.handleAddDataCancel}
                />

                <ConfirmDelete
                    show={this.state.showDelete}
                    data={deleteData}
                    isCenter={false}
                    onDelete={this.handleDelete}
                    onCancel={this.handleCancelDelete}
                />

                <LoadingIndicator
                    type='spin'
                    color='black'
                    loading={this.props.app.loading}
                    message={this.props.app.loadingMessage}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        uploadOptnSrtrData: (hasColumnHeaders, file) => {
            return dispatch(CenterActionCreators.uploadOptnSrtrData(hasColumnHeaders, file));
        },
        validateOptnSrtrData: (fileName, hasColumnHeaders, columnMappings) => {
            return dispatch(CenterActionCreators.validateOptnSrtrData(fileName, hasColumnHeaders, columnMappings));
        },
        processOptnSrtrData: (fileName, hasColumnHeaders, columnMappings) => {
            return dispatch(CenterActionCreators.processOptnSrtrData(fileName, hasColumnHeaders, columnMappings));
        },
        getOptnSrtrProgress: (id) => {
            return dispatch(CenterActionCreators.getOptnSrtrProgress(id));
        },
        getOptnSrtrMonthlyData: () => {
            return dispatch(CenterActionCreators.getOptnSrtrMonthlyData());
        },
        updateOptnSrtrData: (data) => {
            return dispatch(CenterActionCreators.updateOptnSrtrData(data));
        },
        addOptnSrtrData: (data) => {
            return dispatch(CenterActionCreators.addOptnSrtrData(data));
        },
        deleteOptnSrtrData: (list) => {
            return dispatch(CenterActionCreators.deleteOptnSrtrData(list));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(UpdateOptnSrtrData);